import { apiClient } from './client'

export interface SchemaType {
  id: number
  name: string
  type_code: string
  description: string | null
  created_at: string
  updated_at: string
}

export const getSchemaTypes = async (): Promise<SchemaType[]> => {
  const response = await apiClient.get('/api/schema-types')
  return response.data
}

export const createSchemaType = async (data: Omit<SchemaType, 'id' | 'created_at' | 'updated_at'>): Promise<SchemaType> => {
  const response = await apiClient.post('/api/schema-types', data)
  return response.data
}

export const updateSchemaType = async (id: number, data: Partial<SchemaType>): Promise<SchemaType> => {
  const response = await apiClient.put(`/api/schema-types/${id}`, data)
  return response.data
}

export const deleteSchemaType = async (id: number): Promise<void> => {
  await apiClient.delete(`/api/schema-types/${id}`)
}
